import React, { useState, useEffect } from "react";
import Switch from "react-switch";

const CommonSwitch = ({
  defaultChecked = false,
  onToggle,
  disabled = false,
  onColor = "#E443A6",
  offColor = "#0A082F",
  height = 22,
  width = 44,
  handleDiameter = 18,
  checkedIcon = false,
  uncheckedIcon = false,
  className = "",
}) => {
  const [checked, setChecked] = useState(defaultChecked);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  const handleChange = (value) => {
    setChecked(value);
    onToggle?.(value);
  };

  return (
    <Switch
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      onColor={onColor}
      offColor={offColor}
      height={height}
      width={width}
      handleDiameter={handleDiameter}
      checkedIcon={checkedIcon}
      uncheckedIcon={uncheckedIcon}
      className={className}
    />
  );
};

export default CommonSwitch;
